import { render, staticRenderFns } from "./RefuseMealsField.vue?vue&type=template&id=c25609b6&"
import script from "./RefuseMealsField.vue?vue&type=script&lang=js&"
export * from "./RefuseMealsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports